import { AnimatePresence, motion } from 'motion/react';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';

interface MotionDevelopmentProcessProps extends PropsWithChildren {
  className?: string;
  selectedProcess: number;
}

export const MotionDevelopmentProcess = ({
  children,
  className,
  selectedProcess,
}: MotionDevelopmentProcessProps) => {
  return (
    <AnimatePresence mode="wait">
      <MotionDevelopmentProcessWrapper
        className={className}
        key={selectedProcess}
        initial={{ opacity: 0, y: ANIMATION_CONFIG.developmentProcess.yOffset }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          duration: ANIMATION_CONFIG.developmentProcess.duration,
          ease: 'easeInOut',
        }}
      >
        {children}
      </MotionDevelopmentProcessWrapper>
    </AnimatePresence>
  );
};

const MotionDevelopmentProcessWrapper = styled(motion.div)``;
